import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
//import IdentifyGraphic02 from '../img/male-with-bubbles-graphic.svg';
// import IcebergGraphic from './img/iceberg-graphic.svg';
// import GaugeGraphic from './img/emotion-gauge-graphic.svg';

const IdentifyPage = props => {
  const questions = {
    //title: 'Question 1: Types of Indicators',
    type: 'multiple',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={
            'What types of indicators might you be able to pick up on from someone who is experiencing a mental health challenge? ? Select all that apply.'
          }
        />
        <strong>
          What types of indicators might you be able to pick up on from someone who is experiencing a mental health challenge?
        </strong>
        <br />
        (select all that apply)
      </Fragment>
    ),
    result: ['A', 'B', 'C'],
    feedback: {
      correct:
        'Correct! Behaviour, Thoughts and Feelings are all types of indicators that you might identify in someone experiencing mental health challenges.',
      incorrect:
        'Almost. Behaviour, Thoughts and Feelings are all types of indicators that you might identify in someone experiencing mental health challenges.',
      all:
        <div style={{ textAlign: 'left' }}>
          As we identify behaviours, thoughts and feelings, it’s important to note if these indicators seem:
          <ul style={{ listStyle: 'disc', lineHeight: '1em', marginLeft: 30 }}>
            <li>out of character</li>
            <li>to occur suddenly</li>
            <li>to occur frequently</li>
            <li>to persist over time</li>
            <li>to have a significant impact on the individual </li>
            <li>out of character</li>
            <li>and/or</li>
            <li>if it raises specific safety concerns</li>
          </ul>
        </div>
    }
  };
  const options = [
    {
      prefix: 'A',
      result: 'correct',
      optionText: 'Behaviours'
    },
    {
      prefix: 'B',
      result: 'correct',
      optionText: 'Thoughts'
    },
    {
      prefix: 'C',
      result: 'correct',
      optionText: 'Feelings'
    }
  ];

  return (
    <EducationModuleLayout
      progressStage={1}
      childTitle="Identify"
      progressType="identify"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader
                text={
                  'How to Identify When Someone Is Experiencing a Mental Health Challenge?'
                }
              />
              <h2 className="txt-purple no-bold no-margin">
                How to Identify When Someone Is Experiencing a Mental Health Challenge
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="Being able to identify when someone is experiencing a mental health challenge is an essential first step to connect them with the resources they may need. Work through the following question to learn more about indicators that you may recognize." />
              <p>
                Being able to identify when someone is experiencing a mental health challenge
                is an essential first step to connect them with the resources they may need.
                Work through the following question to learn more about indicators that you
                may recognize.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="identify"
        nextRoute={url.IDENTIFY_B}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

IdentifyPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const IdentifyA = IdentifyPage;
export default connect.role(IdentifyA);



// WEBPACK FOOTER //
// ./src/containers/Identify/IdentifyA/index.jsx